import React from 'react';
import Banner from '../components/Banner.js';
import Footer from '../components/Footer.js';
import Cartoon from '../components/Cartoon.js';

function AboutPage() {
  return (
    <div className="page about-page">
      <Banner selected="about" />
      <div className="contents cartoon-container">
        <Cartoon
          messages={[
            // eslint-disable-next-line prettier/prettier
            'Hi, I\'m Ben',
            // eslint-disable-next-line prettier/prettier
            'I\'m looking for a new job',
            'I studied computer science',
            'I have ten years of experience as an engineer',
            'I like to make things',
            'I play music in some small bands',
            'I want to work for a smaller company'
          ]}
        />
      </div>
      <Footer />
    </div>
  );
}

export default AboutPage;
